import {useApi} from "../Api";
import {AncillaryEntityRequest, AncillaryEntityResponse, FormSearchAncillaryModel,} from "../types/ancillary";
import {PagedResponse} from "../types/pagination";
import {buildQueryParams} from "../../utils";
import {SelectElementModelFE} from "../types/generic";

export const useAncillaryRepository = () => {
    const {GET, POST, PUT, DELETE} = useApi();

    const PATH = "/pricing/ancillary";

    function getAncillary(ancillaryId: number): Promise<AncillaryEntityResponse> {
        return GET(`${PATH}?id=${ancillaryId}`);
    }

    function getAncillaries(): Promise<AncillaryEntityResponse[]> {
        return GET(`${PATH}/list`);
    }

    function getAncillariesPaged(
        filters: FormSearchAncillaryModel
    ): Promise<PagedResponse<AncillaryEntityResponse>> {
        const query = "?";

        const queryParams = buildQueryParams(filters);

        return GET(`${PATH}/page/filter${queryParams ? query + queryParams : ""}`);
    }

    function getCloneableAncillaries(
        chargeType: string | undefined,
        showOnlyActive: boolean,
        dealers: SelectElementModelFE | null,
        legalEntities: SelectElementModelFE | null
    ): Promise<AncillaryEntityResponse[]> {
        return GET(
            `${PATH}/get-cloneable?chargeType=${chargeType}&showOnlyActive=${showOnlyActive}&dealers=${dealers}&legalEntities=${legalEntities}`
        );
    }

    function putAncillary(ancillary: AncillaryEntityResponse): Promise<AncillaryEntityResponse> {
        return PUT(`${PATH}`, ancillary);
    }

    function postAncillary(ancillary: AncillaryEntityRequest): Promise<AncillaryEntityResponse> {
        return POST(`${PATH}`, ancillary);
    }

    function deleteAncillary(ancillaryId: number): Promise<string> {
        return DELETE(`${PATH}?id=${ancillaryId}`);
    }

    function terminateAncillary(ancillaryId: number): Promise<AncillaryEntityResponse> {
        return GET(`${PATH}/terminate?id=${ancillaryId}`);
    }

    function getAncillariesBySegmentId(
        filters: FormSearchAncillaryModel
    ): Promise<AncillaryEntityResponse[]> {
        const query = "?";

        const queryParams = buildQueryParams(filters);

        return GET(`${PATH}/filter${queryParams ? query + queryParams : ""}`);
    }

    function getAncillaryInUse({ancillaryId}: { ancillaryId: number }): Promise<boolean> {
        return GET(`${PATH}/in-use?ancillaryId=${ancillaryId}`);
    }

    function getServiceItem(legalEntity: string, dealer: string): Promise<string[]> {
        return GET(`${PATH}/service-item?legalEntity=${legalEntity}&dealer=${dealer}`);
    }

    return {
        getAncillary,
        getAncillaries,
        getAncillariesPaged,
        getCloneableAncillaries,
        deleteAncillary,
        getAncillariesBySegmentId,
        getAncillaryInUse,
        getServiceItem,
        terminateAncillary
    };
};
